// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* div {
  border: 1px solid black;
} */

body, html {
  overflow-x: hidden;
}

.total {
  display: flex;
  flex-direction: column;
  width : 100%;
}

/* section 기본 스타일 */
.section {
  width : 100%;
  transition: height 0.3s ease-in-out;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;;GAEG;;AAEH;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA,mBAAmB;AACnB;EACE,YAAY;EACZ,mCAAmC;AACrC","sourcesContent":["/* div {\n  border: 1px solid black;\n} */\n\nbody, html {\n  overflow-x: hidden;\n}\n\n.total {\n  display: flex;\n  flex-direction: column;\n  width : 100%;\n}\n\n/* section 기본 스타일 */\n.section {\n  width : 100%;\n  transition: height 0.3s ease-in-out;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
